export default __webpack_public_path__ + "static/media/mas-runner-3.c1a6e89f.png";